module.exports = __webpack_public_path__ + "img/fourday_ps_23.b2e0ea89.jpg";